import React from 'react'
import VisDiv from './VisDiv'
import Link from 'next/link'
import {useStateContext} from '../../context/StateContext';


/**
 * A SaveButton component.
 *  #core
 * @param {function} saveFunction - The function to call when the save button is clicked.
 * @param {string} saveDestination - The destination to be passed to the save function.
 * @param {function} cancelFunction - The function to call when the cancel button is clicked.
 * @param {string} cancelDestination - The destination to be passed to the cancel function.
 * @param {array} rules - The rules to be applied to the container.
 * @param {array} saveRules - The rules to be applied to the save button.
 * @param {array} cancelRules - The rules to be applied to the cancel button.
 * @returns {React.ReactElement} A React element representing the SaveButton component.
 */
const SaveButton = ({saveFunction, saveDestination="", cancelFunction, cancelDestination=saveDestination, rules=[], saveRules=[true], cancelRules=[]}) => {
    const {LDB} = useStateContext();
  return (

        <VisDiv rules={rules} className='bottom-buttons'>
            <VisDiv rules ={saveRules} className='bottom-button'>
                <button type="button" style={{backgroundColor:"green"}} className="btn" onClick={saveFunction} >{LDB("misc", "save")}</button>
            </VisDiv>
            <VisDiv rules ={cancelRules} className='bottom-button'>
                <button type="button" style={{backgroundColor:"grey"}} className="btn" onClick={cancelFunction} >{LDB("misc", "cancel")}</button>
            </VisDiv>
        </VisDiv>  

  )
}

export default SaveButton
